import Section from "./Section";

const Footer = () => {
    return (
      <Section responsive style={{height: 140, backgroundColor: 'black'}}>
        <p style={{color: 'white', fontSize: 24, fontFamily: 'Passion One'}}>(912) 632-6520</p>
        <p style={{color: 'white', fontSize: 24, fontFamily: 'Passion One'}}> 202 S Pierce St Alma GA 31510</p>
      </Section>
    );
}

export default Footer;